/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, inject} from '@angular/core';
import {IxActiveModal} from '@siemens/ix-angular';

@Component({
  selector: 'app-qr-code-modal',
  standalone: false,
  templateUrl: './qr-code-modal.component.html',
  styleUrl: './qr-code-modal.component.scss',
})
export class QrCodeModalComponent {
  readonly activeModal = inject(IxActiveModal);
}
